import { render } from "./DetalleVenta.vue?vue&type=template&id=1982eb9e&scoped=true"
import script from "./DetalleVenta.vue?vue&type=script&lang=js"
export * from "./DetalleVenta.vue?vue&type=script&lang=js"

import "./DetalleVenta.vue?vue&type=style&index=0&id=1982eb9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1982eb9e"]])

export default __exports__